import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { usePortalId } from '../../hooks/hub';
import { useTracker } from '../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TasksCompletedCard = ({
  currentViewTitle,
  onRecommendedViewClick,
  recommendedViewName,
  recommendedViewSubTitle,
  recommendedViewTitle
}) => {
  const portalId = usePortalId();
  const {
    trackUserInteraction
  } = useTracker();
  useEffect(() => trackUserInteraction('completed all tasks', recommendedViewName), [recommendedViewName, trackUserInteraction]);
  const defaultSubtitle = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.checklist.complete.doNext"
  });
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "tasks-completed-card",
    flexDirection: "column",
    padding: "600",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "success",
      width: 100
    }), currentViewTitle && /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.checklist.complete.setupComplete",
        options: {
          viewTitle: currentViewTitle
        }
      })
    }), recommendedViewTitle ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        marginBlockStart: "800",
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.checklist.complete.recommend"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: recommendedViewSubTitle || defaultSubtitle
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "recommended-view-button",
        marginBlockStart: "200",
        onClick: () => {
          trackUserInteraction('go to recommended view', recommendedViewName);
          onRecommendedViewClick();
        },
        size: "sm",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.checklist.complete.goToView",
          options: {
            viewTitle: recommendedViewTitle
          }
        })
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        marginBlockStart: "800",
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.checklist.complete.allCompleteTitle"
        })
      }), /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.checklist.complete.allCompleteSubtitle"
        })
      }), /*#__PURE__*/_jsx(UIRouterButton, {
        "data-test-id": "set-homepage-button",
        onClick: () => {
          trackUserInteraction('set new homepage button click');
        },
        size: "sm",
        to: "/change-homepage",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.checklist.complete.setHomepage"
        })
      })]
    }), /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "200",
      typography: "heading-25",
      children: /*#__PURE__*/_jsx(Button, {
        href: `/reports-dashboard/${portalId}`,
        onClick: () => {
          trackUserInteraction('go to dashboard');
        },
        size: "sm",
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.checklist.complete.toDashboard"
        })
      })
    })]
  });
};
export default TasksCompletedCard;